export const companyPriceSurveyProductsColumns = [
  { label: 'Produto', value: 'display_name' },
  { label: 'Preço médio', value: 'price' },
]
